import { useAuth } from '../contexts/AuthContext';

export type PlanId = 'TIER_1' | 'TIER_2';
export type PlanType = 'freemium' | 'pro';

/**
 * Maps entitlement plan_id to application plan type
 * TIER_1 → freemium
 * TIER_2 → pro
 */
export function mapPlanId(planId: PlanId | undefined | null): PlanType {
  if (!planId) {
    console.warn('⚠️ No plan_id provided, defaulting to freemium');
    return 'freemium';
  }

  switch (planId) {
    case 'TIER_1':
      return 'freemium';
    case 'TIER_2':
      return 'pro';
    default:
      console.warn(`⚠️ Unknown plan_id: ${planId}, defaulting to freemium`);
      return 'freemium';
  }
}

/**
 * Hook to get current plan from entitlement
 * Single source of truth for plan detection
 *
 * @returns {{
 *   plan: 'freemium' | 'pro',
 *   isLoading: boolean,
 *   rawPlanId: string | undefined
 * }}
 */
export function usePlan() {
  const { entitlement, entitlementLoading } = useAuth();

  const plan = mapPlanId(entitlement?.plan_id);

  return {
    plan,
    isLoading: entitlementLoading,
    rawPlanId: entitlement?.plan_id,
  };
}
